module.exports = __webpack_public_path__ + "img/C8.8c86a5a6.svg";